import React, { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";

const WebSocketContext = createContext({ socket: null, connected: false, enabled: false });

const WS_URL = (process.env.REACT_APP_WS_URL || "").trim();

export function WebSocketProvider({ children }) {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!WS_URL) return undefined;
    const s = io(WS_URL, {
      transports: ["websocket", "polling"],
      timeout: 5000,
      reconnectionAttempts: 5,
    });
    s.on("connect", () => setConnected(true));
    s.on("disconnect", () => setConnected(false));
    s.on("connect_error", () => setConnected(false));
    setSocket(s);
    return () => {
      s.disconnect();
      setSocket(null);
    };
  }, []);

  return (
    <WebSocketContext.Provider value={{ socket, connected, enabled: !!WS_URL }}>
      {children}
    </WebSocketContext.Provider>
  );
}

export const useWebSocket = () => useContext(WebSocketContext);
